import { render, staticRenderFns } from "./CaseRemoteDesk.vue?vue&type=template&id=21f3fca3"
import script from "./CaseRemoteDesk.vue?vue&type=script&lang=js"
export * from "./CaseRemoteDesk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports